import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const RitualDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Ritual,
  allowsMultipleInstances: false,
  hasCustomUI: true,
  friendlyName: 'Ritual Integration',
  description: `Defines the required properties for a Ritual integration.`,
  category: IntegrationCategoryEnum.FoodOrdering,
  platforms: [PlatformEnum.Mobile, PlatformEnum.Web],
  type: IntegrationTypeEnum.WebView,
  settings: {},
  properties: {},
};

/**
 * @deprecated Use `RitualDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { RitualDefinition } from 'application-types';`
 */
export { RitualDefinition };
